/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var PlusIcon24Solid = forwardRef('PlusIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M11.5 2A1.5 1.5 0 0 1 13 3.5V11h7.5a1.5 1.5 0 0 1 0 3H13v7.5a1.5 1.5 0 0 1-3 0V14H2.5a1.5 1.5 0 0 1 0-3H10V3.5A1.5 1.5 0 0 1 11.5 2Z" })));
});
